import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/constants/site";

export default function Impressum() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-cream py-24 md:py-32" data-testid="impressum-page">
            <div className="max-w-3xl mx-auto px-6">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-gold-deep hover:text-gold transition-colors text-xs tracking-[0.25em] uppercase mb-12"
                    data-testid="impressum-back"
                >
                    <ArrowLeft className="w-4 h-4" /> Startseite
                </Link>

                <h1 className="font-display text-ink text-4xl sm:text-5xl tracking-tight mb-4">Impressum</h1>
                <div className="h-[1px] bg-gold/40 mb-12" />

                <div className="space-y-10 font-sans text-ink/80 leading-relaxed">
                    <section>
                        <h2 className="eyebrow mb-4">Angaben gemäß § 5 DDG</h2>
                        <p className="text-ink font-medium">{SITE.name}</p>
                        <p>Inhaberin: Tijana Alic</p>
                        <p>{SITE.address.street}</p>
                        <p>{SITE.address.city}</p>
                        <p>{SITE.address.country}</p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">Kontakt</h2>
                        <p>Telefon: <a href={`tel:${SITE.phoneRaw}`} className="text-gold-deep hover:text-gold transition-colors">{SITE.phone}</a></p>
                        <p>E-Mail: <a href={`mailto:${SITE.email}`} className="text-gold-deep hover:text-gold transition-colors">{SITE.email}</a></p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">Umsatzsteuer-ID</h2>
                        <p>Eine Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz liegt nicht vor.</p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                        <p>Tijana Alic, Anschrift wie oben</p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">Haftung für Inhalte</h2>
                        <p>
                            Die Inhalte dieser Seite wurden mit großer Sorgfalt erstellt. Für die Richtigkeit,
                            Vollständigkeit und Aktualität der Inhalte wird keine Gewähr übernommen. Als
                            Diensteanbieterin bin ich gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach
                            den allgemeinen Gesetzen verantwortlich.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">Haftung für Links</h2>
                        <p>
                            Diese Website enthält Links zu externen Websites Dritter (z. B. Instagram, WhatsApp,
                            Google Maps), auf deren Inhalte kein Einfluss besteht. Für die Inhalte der verlinkten
                            Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">Urheberrecht</h2>
                        <p>
                            Die auf dieser Website erstellten Inhalte und Werke unterliegen dem deutschen
                            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
                            außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung der
                            jeweiligen Urheberin.
                        </p>
                    </section>
                </div>
            </div>
        </main>
    );
}
